import { ADDTOCART } from "../allProduct/actionIdentifier";
import { multipleAdd } from "../cart/actionCreator";

const checkMultiAdd = (store) => (next) => (action) => {
  const { cart } = store.getState();
  if (action.type === ADDTOCART) {
    if (cart.length && cart.find((product) => product.productId === action.payload.id)) {
      return next(multipleAdd(action.payload.id));
    } else {
      return next(action);
    }
  }
  return next(action);
};

export default checkMultiAdd;
